import * as React from 'react';
import { Space } from '../../Space/src/Space.js';
import { Content } from './Content.js';
import { DoneContent } from './DoneContent.js';

/**
 * @description Stepper component.
 *
 * @component
 * @example
 * ```jsx
 * <Stepper>content</Stepper>
 * ```
 */
const Stepper = React.forwardRef((props, ref) => {
    const { currentStep = 0, totalSteps, label, showLabel, doneContent, showDoneContent, className, ...restProps } = props;
    const isDoneContentVisible = (showDoneContent || doneContent) && currentStep === totalSteps;
    return (React.createElement(Space, { ref: ref, "data-qa": "Stepper", size: 12, align: "center", className: className, ...restProps }, isDoneContentVisible ? (React.createElement(DoneContent, { doneContent: doneContent })) : (React.createElement(Content, { currentStep: currentStep, label: label, showLabel: showLabel, totalSteps: totalSteps }))));
});
Stepper.displayName = 'Stepper';

export { Stepper };
//# sourceMappingURL=Stepper.js.map
